<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('table_search_placeholder') || '原始文件名称 搜索...'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                  >
                    {{ $l('INDEX.advanced_search') || '高级搜索' }}
                  </b-button>
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="$emit('uploadFile')"
              v-if="allow('U')"
            >
              {{ $l('btn_upload') || '上传' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="805px"
      :close-on-click-modal="false"
    >
      <el-form ref="form" :model="form" label-width="105px" size="small">
        <el-row :gutter="10">
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_processFlag') || '文件处理状态'"
            >
              <el-checkbox-group v-model="form.listProcessFlag">
                <el-checkbox label="N">
                  {{ $l('form_label_processFlag_N') || '未处理' }}
                </el-checkbox>
                <el-checkbox label="P">
                  {{ $l('form_label_processFlag_P') || '处理中' }}
                </el-checkbox>
                <el-checkbox label="Y">
                  {{ $l('form_label_processFlag_Y') || '已处理完毕' }}
                </el-checkbox>
                <el-checkbox label="F">
                  {{ $l('form_label_processFlag_F') || '已处理文件有误' }}
                </el-checkbox>
                <el-checkbox label="K">
                  {{ $l('form_label_processFlag_K') || '暂不处理' }}
                </el-checkbox>
                <el-checkbox label="D">
                  {{ $l('form_label_processFlag_D') || '删除数据' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_createBy') || '上传人'">
              <dict-select
                v-model="form.listCreateBy"
                url="/master/common/dict/baseUserSelect"
                :placeholder="$l('form_placeholder_createBy') || '请选择上传人'"
                filterable
                clearable
                multiple
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item :label="$l('form_label_createByTime') || '上传时间'">
              <el-row>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createByTimeStart"
                    :placeholder="
                      $l('form_placeholder_createByTimeStart') ||
                        '请选择上传时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="text-center" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createByTimeEnd"
                    :placeholder="
                      $l('form_placeholder_createByTimeEnd') || '请选择上传时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              :label="$l('form_label_processDatetime') || '处理时间'"
            >
              <el-row>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.processDatetimeStart"
                    :placeholder="
                      $l('form_placeholder_processDatetimeStart') ||
                        '请选择处理时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="text-center" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.processDatetimeEnd"
                    :placeholder="
                      $l('form_placeholder_processDatetimeEnd') ||
                        '请选择处理时间'
                    "
                    value-format="yyyy-MM-dd"
                    type="date"
                    style="width: 100%"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAdvqueryDialog" size="small">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button type="warning" @click="reset" size="small">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button type="primary" @click="advquery" size="small">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = { keyword: '', listProcessFlag: ['N', 'P', 'Y', 'F', 'K'] }
export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
